
// dichiaro il Data Layer
window.dataLayer = window.dataLayer || [];

// Metodo che inizializza il tag manager in base all'id per il cobrand
/*function initGTM(idGTM) {

  // chiamo il gtm script
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer',idGTM);

  // creo i noscript
  var iframe = document.createElement('iframe');
  iframe.height = 0;
  iframe.width = 0;
  iframe.style = 'display:none;visibility:hidden';
  iframe.src = 'https://www.googletagmanager.com/ns.html?id='+idGTM;

  var noscript = document.createElement('noscript');
  noscript.appendChild(iframe);

  var head = document.getElementsByTagName("head")[0];
  head.insertBefore(noscript, head.firstChild);

}*/

// pusho i dati sul data layer
function sendToGTM(part){
  window.dataLayer.push(part);
}
